import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useState, useCallback, useRef } from 'react';
import { EssayAnswerEditorEditComponent } from './essay-answer-editor-edit.component';
import { EssayAnswerEditorPreviewComponent } from './essay-answer-editor-preview.component';
import { AudioPlayerV2, getSize } from '@lib/common';
import { RequestStatus } from '@lib/plugin-redux-core';
import styled from '@xstyled/styled-components';
import { normalizeEssayContent } from './essay-text-metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
var StyledContentWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0 8px;\n"])));
var StyledContentLabel = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 4px;\n"])));
export var EssayAnswerEditorComponent = function EssayAnswerEditorComponent(_ref) {
  var _editMode$find;

  var questionIndex = _ref.questionIndex,
      questionId = _ref.questionId,
      draftAnswer = _ref.draftAnswer,
      answer = _ref.answer,
      onShowingUploadModal = _ref.onShowingUploadModal,
      onShowingAudioUploadModal = _ref.onShowingAudioUploadModal,
      updateAnswerStatus = _ref.updateAnswerStatus,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onUpdateDraftAnswer = _ref.onUpdateDraftAnswer,
      onDeleteDraftAnswer = _ref.onDeleteDraftAnswer,
      label = _ref.label,
      file = _ref.file,
      updateFileAnswerStatus = _ref.updateFileAnswerStatus,
      isHideComponent = _ref.isHideComponent,
      editorLabels = _ref.editorLabels,
      audioFile = _ref.audioFile,
      audioPlayerLabels = _ref.audioPlayerLabels,
      readOnlyStatus = _ref.readOnlyStatus;
  var initValue = draftAnswer || answer;

  var _useState = useState(initValue),
      value = _useState[0],
      setValue = _useState[1];

  var _useState2 = useState(false),
      disabledSaveButton = _useState2[0],
      setDisabledSaveButton = _useState2[1];

  var _useState3 = useState([{
    questionId: questionId,
    status: !!draftAnswer
  }]),
      editMode = _useState3[0],
      setEditMode = _useState3[1];

  var _useState4 = useState(null),
      questionSelected = _useState4[0],
      setQuestionSelected = _useState4[1];

  var _useState5 = useState(false),
      isCancel = _useState5[0],
      setIsCancel = _useState5[1];

  var timeoutRef = useRef(null);
  var isDirty = normalizeEssayContent(value || '') !== normalizeEssayContent(answer || '');
  useEffect(function () {
    if (initValue) {
      setValue(initValue);
    }
  }, [initValue]);
  var editModeStatus = (_editMode$find = editMode.find(function (item) {
    return item.questionId === questionId;
  })) === null || _editMode$find === void 0 ? void 0 : _editMode$find.status;
  var onValueChange = useCallback(function (e) {
    setValue(e);
    onUpdateDraftAnswer(e);
    setDisabledSaveButton(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(function () {
      setDisabledSaveButton(false);
    }, 500);
  }, [onUpdateDraftAnswer]);
  useEffect(function () {
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  useEffect(function () {
    if (isCancel) {
      setValue(answer);
      setIsCancel(false);
    }
  }, [answer, isCancel]);
  useEffect(function () {
    setEditMode(function (prevEditMode) {
      var existingIndex = prevEditMode.findIndex(function (item) {
        return item.questionId === questionId;
      });
      var status = draftAnswer && !!draftAnswer;

      if (existingIndex !== -1) {
        var updatedEditMode = _toConsumableArray(prevEditMode);

        updatedEditMode[existingIndex].status = status;
        return updatedEditMode;
      } else {
        return [].concat(_toConsumableArray(prevEditMode), [{
          questionId: questionSelected,
          status: status
        }]);
      }
    });
  }, [draftAnswer, questionId, questionSelected]);

  var handleUpdateAnswer = function handleUpdateAnswer() {
    setQuestionSelected(questionId);
    onUpdateAnswer(value);
  };

  var handlePreviewModeChange = function handlePreviewModeChange() {
    var newEditMode = editMode.map(function (item) {
      return item.questionId === questionId ? _objectSpread(_objectSpread({}, item), {}, {
        status: false
      }) : item;
    });
    setEditMode(newEditMode);
    setIsCancel(true);
  };

  var handleEditModeChange = function handleEditModeChange() {
    var newEditMode = editMode.map(function (item) {
      return item.questionId === questionId ? _objectSpread(_objectSpread({}, item), {}, {
        status: true
      }) : item;
    });
    setEditMode(newEditMode);
  };

  if (isHideComponent) {
    return null;
  }

  return /*#__PURE__*/_jsxs(StyledWrapper, {
    children: [audioFile && /*#__PURE__*/_jsxs(StyledContentWrapper, {
      children: [/*#__PURE__*/_jsx(StyledContentLabel, {
        children: (label === null || label === void 0 ? void 0 : label.voiceRecord) || 'Student Voice Record'
      }), /*#__PURE__*/_jsx(AudioPlayerV2, {
        source: audioFile.url,
        audioId: "answer-".concat(questionId.toString()),
        audioPlayerConfig: {
          isAllowedToReplay: true,
          isAllowedToPause: true,
          numberOfReplays: -1
        },
        labels: audioPlayerLabels
      })]
    }), /*#__PURE__*/_jsx(StyledContentWrapper, {
      children: editModeStatus ? /*#__PURE__*/_jsx(EssayAnswerEditorEditComponent, {
        questionIndex: questionIndex,
        value: value,
        onChange: onValueChange,
        onShowingUploadModal: onShowingUploadModal,
        onShowingAudioUploadModal: onShowingAudioUploadModal,
        updateAnswerStatus: updateAnswerStatus,
        disabledSaveButtonStatus: !isDirty || disabledSaveButton || updateAnswerStatus === RequestStatus.EXECUTE,
        disabledCancelButtonStatus: disabledSaveButton,
        onUpdateAnswer: handleUpdateAnswer,
        onChangePreviewMode: handlePreviewModeChange,
        onDeleteDraftAnswer: onDeleteDraftAnswer,
        label: label,
        file: file,
        updateFileAnswerStatus: updateFileAnswerStatus,
        editorLabels: editorLabels
      }) : /*#__PURE__*/_jsx(EssayAnswerEditorPreviewComponent, {
        value: value,
        onChangeEditMode: handleEditModeChange,
        label: label,
        canEdit: !readOnlyStatus
      })
    })]
  });
};